<style>

</style>


<div class="next">
  {#if clicked}
  <div class="center">
    <Spinner></Spinner>
  </div>
  {:else}
  <button on:click="{click}" disabled="{disabled}">Next</button>
  {/if}
</div>


<script>

import Spinner from "./Spinner.svelte";


import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let disabled = true;

let clicked = false;

function click() {
  clicked = true;
  dispatch("click");
}

</script>